

















import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import CandidateUpdateGeneral from "./Update/CandidateUpdateGeneral.vue";

@Component({
  components: {
    CandidateUpdateGeneral
  },
  computed: {
    ...mapState("Auth", {
      candidate: "candidate"
    }),
    ...mapState("Country", {
      countries: "countries"
    })
  }
})
export default class BusinessUpdate extends Vue {
  isMounted = false;

  candidate!: Model;
  countries!: [];

  sidebarItems = [
    {
      title: "General"
    }
  ];

  sidebarIndex = 0;

  async created() {
    if (this.countries.length === 0) {
      await this.$store.dispatch("Country/fetchList");
    }
    this.isMounted = true;
  }
}
